import React from "react"
import { Formik, Form as FormikForm, Field, connect } from "formik"
import { Row } from "react-bootstrap"
import * as Yup from "yup"
import FormTextbox from "../../shared/formTextbox"
import FormFieldDisableAutoComplete from "../../shared/formFieldDisableAutoComplete"
import FormRadioButton from "../../shared/formRadioButton"
import FormDatePickerTextBox from "../../shared/formDatePickerTextBox"
import FormDateInputTextbox from "../../shared/formDateInputTextbox"
import FormTimeTextBox from "../../shared/formTimeTextBox"
import FormSectionTitle from "../../shared/formSectionTitle"
import FormDropdownList from "../../shared/formDropdownList"
import FormEditUpload from "../../shared/formEditUpload"
import { isBefore, parse, format, isValid } from "date-fns"

import {
  controlEditBenefit,
  updateValidBenfitFormData,
  updateClickedNext,
  updateFormIsValid,
  pageIncrement,
  completeBenefitForm,
} from "../../../redux/actions"

import * as Constants from "../../../common/constants"
import * as Regex from "../../../common/regex"
import * as ErrorMessage from "../../../common/errorMessage"
import * as CommonFunction from "../../../common/function"
import * as Alert from "../../../services/sweetalertService"

import { useDispatch, useSelector, shallowEqual, batch } from "react-redux"

const DeathForm = ({ coverageDetail }) => {
  const dispatch = useDispatch()
  const formRef = React.useRef()

  const {
    editBenefits,
    allProofDocuments,
    claimUploadListModel,
    clickedNext,
    isComeWithChildCoverage,
    tempBenefitInfo,
    pageNumber,
    chosenedBenefits,
  } = useSelector(state => state.uiData)

  const claimData = useSelector(state => state.claimData, shallowEqual)

  const {
    Category: coverageCategory,
    CoverageCode: coverageCode,
    CoverageDetailId: coverageDetailId,
    CoverageDetailName: coverageDetailName,
  } = coverageDetail

  const formName = coverageCode

  //PA dropdown data
  const { OccurrenceNature } = useSelector(state => state.dropdownData)

  useSelector(state => {
    if (!state.claimData[coverageCategory][coverageCode]) {
      state.claimData[coverageCategory][coverageCode] = {}
    }
  }, shallowEqual)

  const validationSchema = Yup.object().shape({
    occurrenceDate: Yup.date(),
    occurrenceTime: Yup.string().when("occurrenceDate", {
      is: val => {
        // if occurrenceDate got value, occurrenceTime will be required
        if (val) {
          return true
        } else {
          return false
        }
      },
      then: Yup.string()
        .required(ErrorMessage.occurrenceTime)
        .matches(Regex.timepattern, ErrorMessage.occurrenceTime),
    }),

    deathDate: Yup.date().required(ErrorMessage.deathDate),
    deathTime: Yup.string()
      .required(ErrorMessage.deathTime)
      .matches(Regex.timepattern, ErrorMessage.deathTime)
      .test("deathTime", ErrorMessage.futureTimeErrorMsg, value => {
        return CommonFunction.notFutureDatime(
          formRef.current.values.deathDate,
          value
        )
      })
      .test("deathTime", ErrorMessage.deathDateEarlierThanAccident, value => {
        return CommonFunction.isAfterDateTime(
          formRef.current.values.occurrenceDate,
          formRef.current.values.occurrenceTime,
          formRef.current.values.deathDate,
          value
        )
      }),
    deathNature: Yup.string().required(ErrorMessage.deathNature),
    deathReason: Yup.string().required(ErrorMessage.deathReason),
    otherPartyName: Yup.string().when("payOtherParty", {
      is: true, // alternatively: (val) => val == true
      then: Yup.string().required(ErrorMessage.otherPartyName),
    }),
    otherPartyPolicyNumber: Yup.string().when("payOtherParty", {
      is: true,
      then: Yup.string().required(ErrorMessage.otherPartyPolicyNumber),
    }),
    otherPartyDescription: Yup.string().when("payOtherParty", {
      is: true,
      then: Yup.string().required(ErrorMessage.otherPartyDescription),
    }),
    victimName: Yup.string()
      .required(ErrorMessage.disabledVictimName)
      .matches(Regex.namepattern, ErrorMessage.disabledVictimName),
    // victimBirthDate: Yup.date().required(ErrorMessage.birthDate),
    victimBirthDate: Yup.string()
      .required(ErrorMessage.birthDate)
      .length(10, ErrorMessage.birthDate)
      .test("victimBirthDate", ErrorMessage.birthDate, value => {
        const inputDate = parse(
          value,
          `d${Constants.sep}M${Constants.sep}yyyy`,
          new Date()
        )
        const todayDate = parse(
          format(new Date(), "dd/MM/yyyy"),
          `d${Constants.sep}M${Constants.sep}yyyy`,
          new Date()
        )
        return isBefore(inputDate, todayDate) && isValid(inputDate)
      }),
    victimNric: Yup.string()
      .required(ErrorMessage.deathVictimNric)
      .matches(Regex.nricpattern, ErrorMessage.deathVictimNric),
    // claimAmount: Yup.number()
    //   .transform(value => (isNaN(value) ? undefined : value))
    //   .min(1, ErrorMessage.claimAmount),

    // claimAmount: Yup.string()
    // .test(
    //   "claimAmount",
    //   Constants.maximumClaimAmountErrorMsg +
    //     CommonFunction.decimalToString(maxAmount),
    //   value => {
    //     return CommonFunction.validateMaxAmount(value, maxAmount)
    //   }
    // ),
  })

  return (
    <Formik
      initialValues={Object.assign(
        {
          occurrenceDate: "",
          occurrenceTime: "",
          occurrenceDescription: "",
          deathDate: "",
          deathTime: "",
          deathNature: "",
          deathReason: "",
          otherPartyName: "",
          otherPartyPolicyNumber: "",
          otherPartyDescription: "",
          victimName: "",
          victimBirthDate: "",
          victimNric: "",
          // claimAmount: 0,
        },
        claimData[coverageCategory][coverageCode]
      )}
      // enableReinitialize={true}
      validationSchema={validationSchema}
      validateOnMount={true}
      innerRef={formRef}
      onSubmit={(values, actions) => {}}
    >
      {({ handleSubmit, values, handleBlur }) => (
        <>
          <FormikForm onSubmit={handleSubmit}>
            {
              <Row
                className={
                  "form-group " + (editBenefits[coverageCode] ? "" : "hide")
                }
              >
                <div className="col-md-9 col-7 textforinput marginTop10px benefitEditTitle">
                  <p>{coverageDetailName}</p>
                </div>
                <div className="col-md-3 col-5 marginTop10px">
                  <div
                    className="cursorPointer"
                    role="button"
                    tabIndex="0"
                    onClick={() => dispatch(controlEditBenefit(coverageCode))}
                  >
                    <p className="doneEdit">DONE EDIT</p>
                  </div>
                </div>
              </Row>
            }
            {/* Fake fields are a workaround for chrome autofill getting the wrong fields */}
            <Field
              textDesc={"Disable Auto Complete"}
              name="disableAutoComplete"
              component={FormFieldDisableAutoComplete}
            />
            <Field
              textDesc={"Date of Accident"}
              name="occurrenceDate"
              component={FormDatePickerTextBox}
            />

            <Field
              textDesc="Time of Accident (HH:mm)"
              name="occurrenceTime"
              component={FormTimeTextBox}
            />

            <Field
              textDesc={"Description of Accident"}
              maxLength={3000}
              name="occurrenceDescription"
              component={FormTextbox}
            />

            <Field
              textDesc="Date of Death"
              name="deathDate"
              component={FormDatePickerTextBox}
              disableBefore={"occurrenceDate"}
            />
            <Field
              textDesc="Time of Death (HH:mm)"
              name="deathTime"
              component={FormTimeTextBox}
            />

            <Field
              textDesc={"Nature of Death"}
              name="deathNature"
              component={FormDropdownList}
              dropdownItem={OccurrenceNature}
            />

            <Field
              textDesc={"Official Cause of Death"}
              maxLength={200}
              name="deathReason"
              component={FormTextbox}
            />

            <Field
              textDesc={"Is death caused by pre-existing condition?"}
              name="isPreExisting"
              component={FormRadioButton}
            />

            <Field
              textDesc={
                "Have you made a claim against any other party in respect of this event? If yes, please provide"
              }
              name="payOtherParty"
              component={FormRadioButton}
            />
            {values.payOtherParty && (
              <>
                {/* Fake fields are a workaround for chrome autofill getting the wrong fields */}
                <Field
                  textDesc={"Disable Auto Complete"}
                  name="disableAutoComplete2"
                  component={FormFieldDisableAutoComplete}
                />
                <Field
                  textDesc="Name of other party/insurance company"
                  maxLength={100}
                  name="otherPartyName"
                  component={FormTextbox}
                />
                <Field
                  textDesc="Policy number/reference number of other party/insurance company"
                  maxLength={20}
                  name="otherPartyPolicyNumber"
                  component={FormTextbox}
                />
                <Field
                  textDesc="Description of claim made against other party/insurance company"
                  maxLength={3000}
                  name="otherPartyDescription"
                  component={FormTextbox}
                />
              </>
            )}

            <FormSectionTitle text={"Deceased Details"} />

            <Field
              textDesc="Name of Deceased"
              maxLength={100}
              name="victimName"
              component={FormTextbox}
            />
            <Field
              textDesc={"Date of Birth"}
              name="victimBirthDate"
              component={FormDateInputTextbox}
            />
            <Field
              textDesc={"Deceased NRIC"}
              maxLength={9}
              name="victimNric"
              component={FormTextbox}
              toUpperCase={true}
            />

            {/* <Field
                textDesc={"Amount Claimed(SGD)"}
                maxLength={14}
                name="claimAmount"
                component={FormAmountTextBox}
              /> */}

            <FormEditUpload
              editBenefits={editBenefits[coverageCode]}
              coverageDetailId={coverageDetailId}
              coverageDetailName={coverageDetailName}
              allProofDocuments={allProofDocuments}
              claimUploadListModel={claimUploadListModel}
            />

            <HandleFormValidation
              thisPageClickedNext={clickedNext[Constants.benefitFormPageNumber]}
              reviewPageClickedNext={clickedNext[Constants.reviewPageNumber]}
              formRef={formRef}
              values={values}
              thisPageNumber={Constants.benefitFormPageNumber}
              dispatch={dispatch}
              formName={formName}
              coverageCategory={coverageCategory}
              coverageCode={coverageCode}
              tempBenefitInfo={tempBenefitInfo}
              chosenedBenefits={chosenedBenefits}
            />
            {/* <HandleClaimAmountUpdate
              claimAmount={values.claimAmount}
              dispatch={dispatch}
              pageNumber={pageNumber}
              coverageCategory={coverageCategory}
              coverageCode={coverageCode}
              formRef={formRef}
            /> */}
          </FormikForm>
        </>
      )}
    </Formik>
  )
}

const HandleFormValidation = ({
  thisPageClickedNext,
  reviewPageClickedNext,
  formRef,
  values,
  thisPageNumber,
  dispatch,
  formName,
  coverageCategory,
  coverageCode,
  tempBenefitInfo,
  chosenedBenefits,
}) => {
  React.useEffect(() => {
    if (
      (thisPageClickedNext && coverageCode === tempBenefitInfo.CoverageCode) ||
      (reviewPageClickedNext &&
        CommonFunction.checkBenefitChosened(chosenedBenefits, coverageCode))
    ) {
      // console.log(formRef.current)
      formRef.current.validateForm().then(errors => {
        // console.log(errors)

        batch(() => {
          if (Object.entries(errors).length === 0) {
            // console.log("PASS")

            dispatch(
              updateValidBenfitFormData(coverageCategory, coverageCode, values)
            )
            if (thisPageClickedNext) {
              dispatch(pageIncrement())
              dispatch(completeBenefitForm(coverageCode))
            } else {
              dispatch(updateFormIsValid(formName, true))
            }
          } else {
            if (thisPageClickedNext) {
              Alert.missingInfoAlert()
            } else {
              dispatch(updateFormIsValid(formName, false))
            }
            formRef.current.submitForm() // Set touched to all fields
          }

          dispatch(updateClickedNext(thisPageNumber, false))
        })
      })
    }
  }, [
    thisPageClickedNext,
    reviewPageClickedNext,
    formRef,
    values,
    thisPageNumber,
    dispatch,
    formName,
    coverageCategory,
    coverageCode,
    tempBenefitInfo,
  ])
  return null
}

// const HandleClaimAmountUpdate = ({
//   claimAmount,
//   dispatch,
//   pageNumber,
//   coverageCategory,
//   coverageCode,
//   formRef,
// }) => {
//   React.useEffect(() => {
//     if (pageNumber === Constants.reviewPageNumber) {
//       setTimeout(() => {
//       batch(() => {
//         dispatch(
//           updateValidBenfitFormData(
//             coverageCategory,
//             coverageCode,
//             formRef.current.values
//           )
//         )
//       })
//       }, 1000);
//     }
//   }, [claimAmount])

//   return null
// }

export default DeathForm
